export default {
  middleware_url: "https://lmi85.fluid-it.fr",
  cake_url: "https://cake.lmi85.fluid-it.fr",
  pwa_url: "https://app.lmi85.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "26",
  googleMap: {
    api: "AIzaSyCqar1mHX7fVU5vaWHamIoSOIsK6_0q27E",
  },
};
